
import Cookies from "js-cookie";

// Constants
export const REFERRAL_COOKIE_NAME = "metrade_referral_code";
export const AFFILIATE_COOKIE_NAME = "metrade_affiliate_id";
export const CAMPAIGN_COOKIE_NAME = "CAMPAIGN_COOKIE";
export const REFERRAL_COOKIE_EXPIRY = 30; // days
export const CAMPAIGN_COOKIE_EXPIRY = 365; // Default expiry (used when no custom expiry provided)

// Helper functions
export const getReferralCodeFromCookie = (): string | null => {
  return Cookies.get(REFERRAL_COOKIE_NAME) || null;
};

export const getAffiliateIdFromCookie = (): string | null => {
  return Cookies.get(AFFILIATE_COOKIE_NAME) || null;
};

export const getCampaignCookie = (): string | null => {
  return Cookies.get(CAMPAIGN_COOKIE_NAME) || null;
};

export const removeCampaignCookie = () => {
  Cookies.remove(CAMPAIGN_COOKIE_NAME);
}

export const storeReferralCodeInCookie = (referralCode: string): void => {
  try {
    // Only store if we don't already have a referral code
    if (!Cookies.get(REFERRAL_COOKIE_NAME)) {
      console.log("Setting referral cookie:", referralCode);
      Cookies.set(REFERRAL_COOKIE_NAME, referralCode, { 
        expires: REFERRAL_COOKIE_EXPIRY,
        sameSite: "strict"
      });
    } else {
      console.log("Referral cookie already exists. Not overwriting existing value:", Cookies.get(REFERRAL_COOKIE_NAME));
    }
  } catch (error) {
    console.error("Error storing referral code in cookie:", error);
  }
};

export const storeAffiliateIdInCookie = (affiliateId: string): void => {
  try {
    // Only store if we don't already have an affiliate ID
    //if (!Cookies.get(AFFILIATE_COOKIE_NAME)) {
      console.log("Setting affiliate cookie:", affiliateId);
      Cookies.set(AFFILIATE_COOKIE_NAME, affiliateId, { 
        expires: REFERRAL_COOKIE_EXPIRY,
        sameSite: "strict"
      });
    /*} else {
      console.log("Affiliate cookie already exists. Not overwriting existing value:", Cookies.get(AFFILIATE_COOKIE_NAME));
    }*/
  } catch (error) {
    console.error("Error storing affiliate ID in cookie:", error);
  }
};

export const storeCampaignCookie = (campaignValue: string, expiryDays: number = CAMPAIGN_COOKIE_EXPIRY): void => {
  try {
    // Check if campaign cookie already exists
    const existingCampaign = Cookies.get(CAMPAIGN_COOKIE_NAME);
    
    // Only set the cookie if it doesn't already exist
    if (!existingCampaign) {
      console.log(`Setting campaign cookie: ${campaignValue} with expiry: ${expiryDays} days`);
      Cookies.set(CAMPAIGN_COOKIE_NAME, campaignValue, { 
        expires: expiryDays,
        sameSite: "strict",
        path: "/"
      });
    } else {
      console.log(`Campaign cookie already exists with value: ${existingCampaign}. Not overwriting.`);
    }
  } catch (error) {
    console.error(`Error storing campaign cookie:`, error);
  }
};

export const createReferralLink = (referralCode: string | null): string => {
  if (!referralCode) return "";
  const baseUrl = window.location.origin;
  return `${baseUrl}?referralCode=${referralCode}`;
};

export const calculateNextMilestone = (paidCount: number): number => {
  return paidCount < 10 ? 10 : Math.ceil(paidCount / 10) * 10;
};
